export default __webpack_public_path__ + "static/media/Preparacion.6a7fdcb5.jpeg";